export interface IButtonProps {
  tier?: ButtonTier;
  intent?: ButtonIntent;
  bigger?: boolean;
}

export enum ButtonTier {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export enum ButtonIntent {
  Positive = 'positive',
  Negative = 'negative',
}
